module.exports = "<!--Что это!?-->\n<div><div class=\"flex-end\" fxLayout=\"row\" fxLayoutAlign=\"flex-end center\">\n  <button md-icon-button md-dialog-close><md-icon>clear</md-icon></button>\n</div>\n\n  <md-dialog-content style=\"width: 80vw; height: 80vh;\">\n    <button md-icon-button md-dialog-close>LOX</button>\n  </md-dialog-content>\n  <md-dialog-actions>\n\n  </md-dialog-actions></div>\n"


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/src/app/admin/dialog-confirm.html
// module id = ../../../../../src/app/admin/dialog-confirm.html
// module chunks = 0